
import { PropType, computed, useContext } from '@nuxtjs/composition-api'
import { isEmpty } from 'lodash-es'
import { AatriumProduct } from '~/modules/catalog/types'
import { getProductSku, getName, getPrice, getMagentoId, getSlug, getId, getCoverImage } from '~/modules/catalog/product/getters/productGetters'
import { createProductPath } from '~/modules/product-correct-url/helpers'

export default {
  name: 'MicrodataProduct',
  props: {
    product: {
      type: Object as PropType<AatriumProduct>,
      default: null
    }
  },
  setup (props) {
    const { $config } = useContext()
    const { storeURL } = $config

    const currentProduct = computed<AatriumProduct>(() => props.product)
    const microdataJson = computed(() => {
      if (isEmpty(currentProduct.value)) {
        return null
      }

      const jsonData = {
        '@context': 'http://schema.org',
        '@type': 'Product',
        productID: getMagentoId(currentProduct.value),
        sku: getProductSku(currentProduct.value),
        name: getName(currentProduct.value),
        description: currentProduct.value.description?.html ?? '',
        category: currentProduct.value.categories.map(i => i.name),
        width: currentProduct.value?.width ?? '',
        height: currentProduct.value?.height ?? '',
        image: getCoverImage(currentProduct.value),
        identifier: getId(currentProduct.value),
        url: storeURL + createProductPath(getProductSku(currentProduct.value), getSlug(currentProduct.value)),
        offers: {
          '@type': 'Offer',
          price: getPrice(currentProduct.value).final,
          priceCurrency: 'EUR'
        }
      }

      // TODO: Keys not yet implemented.
      // brand: 'not available',
      // manufacturer: 'not available',
      // material: 'not available',
      // pattern: 'not available',
      // color: 'not available',
      // size: 'not available',
      // weight: 'not available'

      return JSON.stringify(jsonData, null)
    })

    return {
      microdataJson
    }
  }
}
